module.exports = __webpack_public_path__ + "img/neptune.5857275e.png";